import SvgIcon from '@mui/material/SvgIcon';

const NineGagLogo = () => {
  return (
    <SvgIcon sx={{ width: 44, height: 44 }} viewBox="75 70 455 455">
      <path
        fill="white"
        fillRule="evenodd"
        d="M 383.59022,438.0924 l 80.57725,-46.49014 0,-93.26972 0,-93.26973 -80.57725,-46.49013 c -44.31749,-25.56958 -81.18272,-46.49014 -81.92276,-46.49014 -0.74004,0 -37.60528,20.92056 -81.92276,46.49014 l -80.57724,46.49013 0,18.26973 0,18.26972 80.57724,46.49014 c 44.31748,25.56958 81.18767,46.49014 81.93376,46.49014 0.74607,0 22.79295,-12.375 48.99302,-27.5 26.20009,-15.125 47.82989,-27.5 48.06629,-27.5 0.2363,0 0.4205,17.01562 0.4092,37.8125 l -0.02,37.8125 -47.73542,27.5 c -26.25448,15.125 -48.34454,27.65886 -49.08903,27.85302 -0.74448,0.19418 -22.82164,-12.0402 -49.06034,-27.1875 -26.23868,-15.14728 -48.31448,-27.54052 -49.05732,-27.54052 -2.40989,0 -62.63374,35.27449 -62.24009,36.45544 0.48288,1.44864 157.28208,92.13896 159.45845,92.22839 0.88564,0.0364 37.87001,-20.85439 82.1875,-46.42397 z
        M 268.25242,242.28924 c -17.34701,-10.08244 -31.54197,-18.61295 -31.54435,-18.9567 -0.007,-1.10159 63.01121,-36.875 64.95939,-36.875 1.94541,0 64.9637,35.77074 64.9637,36.875 0,0.98304 -62.81065,36.85065 -64.93673,37.0817 -1.04608,0.11363 -16.09498,-8.04257 -33.44201,-18.125 z"
      />
    </SvgIcon>
  );
};

export default NineGagLogo;
